/* src/app/promo-plan/list-promo-plan/list-promo-plan.component.css */
/*# sourceMappingURL=list-promo-plan.component-ZEAEZ4ZG.css.map */
